// @flow

import * as React from 'react';
import {useMerchantCurrency} from 'docs/hooks';
import {FormattedNumber} from 'react-intl';

const ZERO_DECIMAL_CURRENCIES = [
  'bif',
  'clp',
  'djf',
  'gnf',
  'jpy',
  'kmf',
  'krw',
  'mga',
  'pyg',
  'rwf',
  'ugx',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
];

type CurrencyProps = {|
  amount: number,
  zeroDecimalAmount?: number,
  overrideCurrency?: string,
|};

export const Currency = ({
  amount,
  zeroDecimalAmount,
  overrideCurrency,
}: CurrencyProps) => {
  const merchantCurrency = useMerchantCurrency();
  const currency = overrideCurrency || merchantCurrency;

  if (!currency) {
    // If for some reason we cannot detect the currency, fallback to USD.
    return <span>{amount} USD</span>;
  }

  // Use the zero-decimal amount if provided and if the currency is a zero-decimal currency
  let value = amount;
  if (
    ZERO_DECIMAL_CURRENCIES.includes(currency.toLowerCase()) &&
    zeroDecimalAmount != null
  ) {
    value = zeroDecimalAmount;
  }

  return <FormattedNumber value={value} style="currency" currency={currency} />;
};
